<template>
  <v-card>
    <v-card-title class="px-6">
      Select High & Low Categories
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="subtitle-1 px-6 pt-6">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        disable-pagination
        hide-default-footer
        show-select
        item-key="id"
      >
      </v-data-table>
    </v-card-text>
    <v-card-actions class="pt-0 px-6">
      <v-btn color="primary" large :loading="saving" @click="save" class="mr-4">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PulseHighLowCategories",
  components: {},
  props: {},
  data: () => ({
    saving: false,
    valid: false,
    loading: false,
    selected: [],
    items: [],
    headers: [
      { text: "Category", value: "categoryName" },
      { text: "Sub-Category/Core Value", value: "relatedItemName" }
    ]
  }),
  watch: {},
  computed: {
    ...mapGetters({
      categories: "pulse/categories"
    })
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      Promise.all([this.$store.dispatch("pulse/getQuestions")])
        .then(() => {
          this.selected = [];
          this.items = [];

          this.categories
            .filter(x => x.isEnabled)
            .forEach(x => {
              let categoryId = `${x.id}||`;
              let item = { categoryName: x.name, id: categoryId };
              this.items.push({ categoryName: x.name, id: categoryId });
              if (x.isHighLow) {
                this.selected.push(item);
              }
              x.relatedItems.forEach(y => {
                let relatedItemId = `${x.id}|${
                  y.type == this.$enums.pulseRelatedItemTypes.SUB_CATEGORY
                    ? y.id
                    : ""
                }|${
                  y.type == this.$enums.pulseRelatedItemTypes.CORE_VALUE
                    ? y.id
                    : ""
                }`;
                let item = {
                  categoryName: x.name,
                  relatedItemName: y.name,
                  id: relatedItemId
                };
                this.items.push(item);
                if (y.isHighLow) {
                  this.selected.push(item);
                }
              });
            });
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading questions."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      this.saving = true;

      let list = this.selected.map(x => {
        let val = x.id.split("|");
        return {
          pulseCategoryId: val[0],
          pulseSubCategoryId: val[1],
          companyCoreValueId: val[2]
        };
      });

      this.$store
        .dispatch("pulse/saveHighLow", list)
        .then(() => {
          this.$emit("save");
          this.$store.dispatch("profile/getProfile");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while saving your culture tracking settings."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
